<div class="row">
    <iui-messages #messages  class="ms-auto me-auto"></iui-messages>
</div>
<div>
    <div class="row mt-4">
        <h5 class="col-md-8">
            <b>You may see a temporary "authorization hold" of $1.00 on your credit card statement; rest assured,
            it will be released within 3-14 days. This is simply a method to validate your credit card information and prevent
            credit card fraud.</b>
        </h5>
    </div>

    <div class="row">
        <form [formGroup]="creditCardForm" (ngSubmit)="submit()" class="col-10">
            <div class="row">
                <div class="col-12">
                    <app-address-book (addressChosen)="loadAddress($event)"></app-address-book>
                </div>
            </div>
            <div class="row mt-4">
                <div class="mb-3 col-md-4">
                    <label for="firstName" class="required">First Name</label>
                    <input class="form-control" appScrText formControlName="firstName" id="firstName" placeholder="First Name" 
                    maxlength="{{MaxLen.FirstName}}" autocomplete="cc-given-name"
                    [ngClass]="{'error-input': creditCardForm.get('firstName')!.invalid && submitted === true}"/>
                    <ng-container *ngIf="creditCardForm.get('firstName')!.invalid && submitted === true">
                        <span *ngIf="creditCardForm.get('firstName')!.errors?.required" class="failed">First Name is required.</span>
                        <span *ngIf="creditCardForm.get('firstName')!.errors?.appFirstNameValidator" class="failed">First Name has an invalid format.</span>
                    </ng-container>
                </div>
                <div class="mb-3 col-md-4">
                    <label for="lastName" class="required">Last Name</label>
                    <input class="form-control" appScrText formControlName="lastName" id="lastName" placeholder="Last Name"
                     maxlength="{{MaxLen.LastName}}" autocomplete="cc-family-name"
                     [ngClass]="{'error-input': creditCardForm.get('lastName')!.invalid && submitted === true}"/>
                    <ng-container *ngIf="creditCardForm.get('lastName')!.invalid && submitted === true">
                        <span *ngIf="creditCardForm.get('lastName')!.errors?.required" class="failed">Last Name is required.</span>
                        <span *ngIf="creditCardForm.get('lastName')!.errors?.appLastNameValidator" class="failed">Last Name has an invalid format.</span>
                    </ng-container>
                </div>
            </div> 
            <div class="row">
                <div class="mb-3 col-md-4">
                    <label for="country" class="required">Country</label>
                    <p-dropdown appDd #country [styleClass]="creditCardForm.get('country')!.invalid && submitted ? 'field-errors ' : ''"  
                        [options]="countries" [filter]="true" autocomplete="billing country-name"
                        optionLabel="countryName" optionValue="country"  (onChange)="getRegions($event.value, true)" 
                        formControlName="country" id="country" placeholder="Country" >
                    </p-dropdown>
                </div>
            </div>
            
            <div class="row">
                <div class="mb-3 col-md-12">
                    <label for="address1" class="required">Street Address 1</label>
                    <input class="form-control" appScrText formControlName="address1" placeholder="Street Address" id="address1" 
                    maxlength="{{MaxLen.Address}}" autocomplete="billing address-line1"
                        [ngClass]="{'error-input': creditCardForm.get('address1')!.invalid && submitted === true}"/>
                    <ng-container *ngIf="creditCardForm.get('address1')!.invalid && submitted === true">
                        <span *ngIf="creditCardForm.get('address1')!.errors?.required" class="failed">Street Address 1 is required.</span>
                    </ng-container>
                </div>
            </div> 
            <div class="row">
                <div class="mb-3 col-md-12">
                    <label for="address2">Street Address 2</label>
                    <input class="form-control" appScrText formControlName="address2" id="address2" placeholder="Street Address 2" 
                    autocomplete="billing address-line2" maxlength="{{MaxLen.Address}}" />
                </div>
            </div> 
            
            <div class="row">
                <div class="mb-3 col-md-4">
                    <label for="city" class="required">City</label>
                    <input class="form-control" appScrText formControlName="city" id="city" placeholder="City" maxlength="{{MaxLen.City}}"
                        autocomplete="billing address-level2"
                        [ngClass]="{'error-input': creditCardForm.get('city')!.invalid && submitted === true}"/>  
                    <ng-container *ngIf="creditCardForm.get('city')!.invalid && submitted === true">
                        <span *ngIf="creditCardForm.get('city')!.errors?.required" class="failed">City is required.</span>
                    </ng-container>               
                </div>
                <div class="mb-3 col-md-4">
                    <label for="state" [ngClass]="{'required': creditCardForm.get('country')?.value === 'us' ||
                        creditCardForm.get('country')?.value === 'ca'}">State/Province </label>
                    <p-dropdown appDd #state [styleClass]="creditCardForm.get('state')!.invalid && submitted ? 'field-errors ' : ''" 
                        [options]="regionList" [filter]="true" id="state" appDd autocomplete="billing address-level1"
                        optionLabel="regionName" optionValue="region" [disabled]="regionList.length === 0"
                        formControlName="state" [placeholder]="regionList.length > 0 ? 'Select' : 'Not Available'">
                    </p-dropdown>
                    <ng-container *ngIf="creditCardForm.get('state')!.invalid && submitted === true">
                        <span *ngIf="creditCardForm.get('state')!.errors?.required" class="failed">State/Province is required.</span>
                    </ng-container>     
                </div>

                <div class="mb-3 col-md-4">
                    <label for="zip" [ngClass]="{'required': creditCardForm.get('country')?.value === 'us' || 
                        creditCardForm.get('country')?.value === 'ca'}"> Zip/Postal Code </label>
                    <input class="form-control" *ngIf="creditCardForm.get('country')?.value === 'us'" appScrText mask="00000||00000-0000" formControlName="zip" id="zip"
                        autocomplete="billing postal-code"
                        placeholder="Zip/Postal Code" [dropSpecialCharacters]="false" maxlength="{{MaxLen.Zip}}" [validation]="true"
                        [ngClass]="{'error-input': creditCardForm.get('zip')!.invalid && submitted === true}"/>
                    <input class="form-control" *ngIf="creditCardForm.get('country')?.value !== 'us'" appScrText [mask]="dynamicMask" formControlName="zip" id="zip"
                        placeholder="Zip/Postal Code" [dropSpecialCharacters]="false" maxlength="{{MaxLen.Zip}}"
                         appZip [country]="creditCardForm.get('country')?.value"
                        [ngClass]="{'error-input': creditCardForm.get('zip')!.invalid && submitted === true}"/>
                    <ng-container *ngIf="creditCardForm.get('zip')!.invalid && submitted === true && creditCardForm.get('country')?.value === 'us'">
                        <span *ngIf="creditCardForm.get('zip')!.errors?.required" class="failed">Zip/Postal Code is required.</span>
                    </ng-container>
                    <ng-container *ngIf="creditCardForm.get('zip')!.invalid && submitted === true && creditCardForm.get('country')?.value === 'ca'">
                        <span *ngIf="creditCardForm.get('zip')!.errors?.required" class="failed">Zip/Postal Code is required.</span>
                    </ng-container>
                    <ng-container *ngIf="(creditCardForm.get('zip')!.errors?.invalid || creditCardForm.get('zip')!.errors?.mask) && submitted === true && creditCardForm.get('country')?.value === 'ca'" >
                        <span class="failed">Zip/Postal Code is invalid. (example: A1A 1A1)</span>
                    </ng-container>
                    <ng-container *ngIf="(creditCardForm.get('zip')!.errors?.invalid || creditCardForm.get('zip')!.errors?.mask) && submitted === true && creditCardForm.get('country')?.value === 'us'" >
                        <span class="failed">Zip/Postal Code is invalid. (example: 99999 or 99999-9999)</span>
                    </ng-container>
                </div>

            </div>

            <div class="row">
                <div class="mb-3 col-md-7">
                    <label for="description">Description</label>
                    <input class="form-control" appScrText formControlName="description" id="description" placeholder="Description" maxlength="30"/>
                </div>
            </div>

            <div class="row">
                <div class="mb-3 col-md-3">
                    <label for="cardType" class="required">Card Type</label>
                    <p-dropdown appDd [styleClass]="creditCardForm.get('cardType')!.invalid && submitted ? 'field-errors ' : ''" 
                        [options]="cards" [filter]="true" id="cardType" autocomplete="cc-type"
                        optionLabel="name" optionValue="code" formControlName="cardType" placeholder="Card Type" >
                    </p-dropdown>
                    <ng-container *ngIf="creditCardForm.get('cardType')!.invalid && submitted === true">
                        <span *ngIf="creditCardForm.get('cardType')!.errors?.required" class="failed">Card Type is required.</span>
                    </ng-container> 
                </div>
            </div>

            <div class="row">
                <div class="mb-3 col-md-3">
                    <label for="creditCardNumber" class="required">Credit Card Number</label>
                    <input class="form-control" appScrText type="tel" appCcNumber #ccNumber="appCcNumber" (focusout)="cardTypeFromNum()" (input)="limitCcLength($event)"
                            formControlName="creditCardNumber" placeholder="Credit Card Number" id="creditCardNumber" autocomplete="cc-number"
                            [ngClass]="{'error-input': 
                            (creditCardForm.get('creditCardNumber')!.invalid || creditCardForm.errors?.cardNumTypeMismatch)&& submitted === true}"/>
                            <ng-container *ngIf="creditCardForm.get('creditCardNumber')!.invalid && submitted === true">
                            <span *ngIf="creditCardForm.get('creditCardNumber')!.errors?.required" class="form-text failed text-nowrap">Credit Card Number is required.</span>
                            <span *ngIf="creditCardForm.get('creditCardNumber')!.errors?.appCcNumber && 
                                !creditCardForm.get('creditCardNumber')!.errors?.required" class="text-nowrap form-text failed" 
                                [innerHTML]="getCardError(creditCardForm.get('cardType')?.value, creditCardForm.get('creditCardNumber')?.value)"></span>
                        </ng-container>
                        <ng-container *ngIf="creditCardForm.errors?.cardNumTypeMismatch && submitted === true && !creditCardForm.get('creditCardNumber')!.errors?.appCcNumber">
                            <span class="failed text-nowrap form-text">Credit Card Number has an invalid format.</span>
                        </ng-container>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <h5 id="expirationDate" class="mt-0"><b>Expiration Date</b></h5>
                </div>
            </div>
            <div class="row mt-2" id="cardTypeLib">
                <div class="mb-3 col-md-2">
                    <label for="expirationMonth" class="required">Month</label>
                    <p-dropdown appDd [styleClass]="(creditCardForm.errors?.cardExpiration || creditCardForm.get('expirationMonth')!.invalid) && submitted ? 
                        'field-errors ' : ''" 
                        [options]="months" [filter]="true" id="expirationMonth" autocomplete="cc-exp-month"
                        formControlName="expirationMonth" placeholder="Month" (onChange)="setCreditcardDate()">
                    </p-dropdown>
                    <ng-container *ngIf="creditCardForm.get('expirationMonth')!.invalid && submitted === true">
                        <span *ngIf="creditCardForm.get('expirationMonth')!.errors?.required" class="failed">Month is required.</span>
                    </ng-container> 
                </div>
                <div class="mb-3 col-md-2">
                    <label for="expirationYear" class="required">Year</label>
                    <p-dropdown appDd [styleClass]="(creditCardForm.errors?.cardExpiration || creditCardForm.get('expirationYear')!.invalid) && submitted ? 
                        'field-errors ' : ''" [options]="years" [filter]="true" id="expirationYear" autocomplete="cc-exp-year"
                        formControlName="expirationYear" placeholder="Year" (onChange)="setCreditcardDate()">
                </p-dropdown>
                <ng-container *ngIf="creditCardForm.get('expirationYear')!.invalid && submitted === true">
                    <span *ngIf="creditCardForm.get('expirationYear')!.errors?.required" class="failed">Year is required.</span>
                </ng-container> 
                </div>
            </div>
            <ng-container *ngIf="creditCardForm.errors?.cardExpiration && submitted === true">
                <div class="failed mb-2">The credit card you are attempting to use has expired.</div>
            </ng-container>
            <div class="row">
                <div class="col-md-12">
                    <label for="cc-cvc" class="required">Card Verification Value (CVV)
                        <sup><i class="fa fa-circle-info large" style="color: #004381; margin-left: .1em;" 
                        pTooltip="For your safety and security, we require that you enter your card verification number.
                        For Visa, MasterCard, and Discover cards, the card verification number is the last 3 digit number located on the back of your 
                        card on or above your signature line. For an American Express card, it is the 4 digits on the front above the end of your card number." 
                        tooltipPosition="top" tooltipStyleClass="toolCardData" appendTo="body"></i></sup>
                    </label>
                </div>
            </div>
            <div class="form-row">
                <div class="mb-3 col-md-2">
                    <input appScrText id="cc-cvc" type="tel" autocomplete="cc-csc" ccCVC formControlName="cvv" placeholder="CVV"
                    [ngClass]="{'error-input': creditCardForm.get('cvv')!.invalid && submitted === true}"/>
                    <ng-container *ngIf="creditCardForm.get('cvv')!.invalid && submitted === true">
                        <span *ngIf="creditCardForm.get('cvv')!.errors?.required" class="nowrap failed">Card Verification Value (CVV) is required.
                        </span>
                        <span *ngIf="creditCardForm.get('cvv')!.errors?.cvvLength" class="nowrap failed">Card Verification Value (CVV) has an invalid format.
                        </span>
                        <span *ngIf="creditCardForm.get('cvv')!.errors?.cvvLengthAmex" class="nowrap failed">Card Verification Value (CVV) has an invalid format.
                        </span>
                    </ng-container> 
                </div>
            </div>
            <div class="form-row">
                <div class="mb-3 col-md-8">
                    <p-checkbox class="p-formcontrol" label="Set as default" id="default" [binary]="true" value="false" formControlName="default"></p-checkbox>
                </div>
            </div>
            <div class="form-row">
                <div class="col small ms-4">
                    Setting this as the default payment method indicates that this payment method will be used for auto-renew.
                </div>
            </div>
            <div class="d-flex justify-content-start mt-3">
                <button class="btn btn-primary me-4" submit>Save Payment Method</button>
                <button class="btn btn-secondary" type="button" (click)="confirmCancelDialog()">Cancel</button>
            </div>
        </form>
    </div>
    <p-confirmDialog key='confirmCancel' #creditFormCancel width="425" [closable]="false">
        <p-footer>
            <div class="d-flex justify-content-end">
                <button i18n id="scaccept" class="btn btn-primary me-2" type="button" (click)="creditFormCancel.accept()">Yes</button>
                <button i18n id="screject" class="btn btn-secondary" type="button" (click)="creditFormCancel.reject()">No</button>
            </div>
        </p-footer>
    </p-confirmDialog>
</div>
        